import * as _ from "lodash";
interface Action {
    payload: any,
    type: string,
    field: string,
    subfield?: string
    value?: { length?: number },
    validate: boolean,
}

const errors: {
    [key: string]: string
} = {
    court: "Please select a courthouse.",
    department: "Please select a department.",
    city: "Please add city.",
    zip: "Please add zip code.",
    street: "Please add street address.",
    full_address: "Please add address.",
};

const manuallyFields = ['court', 'department', 'city','zip','street'];
const commonFields = ['court','department'];

export default (data: any, action: Action) => {

    const newForm = {...data};
    let requiredFields = {};
    const prop = newForm[action.field];
    const length = action?.value?.length || 0;

    if (prop) {
        action.value = action.value === ' ' ? '' : action.value;

        if (!prop.added && (action.value || (!action.value && action.validate))) {
            prop.added = true
        }
        if (!prop.dirty && action.validate) {
            prop.dirty = true;
        }

        prop.error = (prop.added && !action.value && prop.required) || (prop.min && prop.min > length) ? errors[action.field] : null;
        prop.value = action.value;

    }

    if (newForm.department?.value?.id && newForm.department?.value?.id === -2) {
        requiredFields = _.pick(newForm, manuallyFields);
    } else {
        requiredFields = _.pick(newForm, commonFields);
    }

    const vals = Object.values(requiredFields || newForm).filter((f: any) => f.required);
    const valid = vals.filter((f: any) => f.added && f.value && !f.error);

    return {
        changed: true,
        valid: vals.length === valid.length,
        data: newForm,
    };
};
